var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M0-682.665H50v50H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery_Address",
    "data-name": "Delivery Address",
    transform: "translate(5847 4665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6042",
    "data-name": "Group 6042",
    transform: "translate(-6888 -4969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "translate(-5813 -3950.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(1.953 16.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M-190.294-42.013l-6.569-2.861a6.152,6.152,0,0,0-8.47,5.7v13.807a8.789,8.789,0,0,0,5.478,8.142l6.284,2.556a10.742,10.742,0,0,0,5.952.621l13.731-2.865,6.179,2.568a6.152,6.152,0,0,0,8.47-5.7v-13.8a8.789,8.789,0,0,0-5.478-8.142L-171-44.542a10.772,10.772,0,0,0-3.374-.791",
    transform: "translate(205.333 45.333)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(33.008 24.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M0,0V13.078",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(16.992 27.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M0-164.345v-12.988",
    transform: "translate(0 177.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g37",
    transform: "translate(20.117 1.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M-123.567-61.784A4.883,4.883,0,0,1-128.45-56.9a4.883,4.883,0,0,1-4.883-4.883,4.883,4.883,0,0,1,4.883-4.883A4.883,4.883,0,0,1-123.567-61.784Z",
    transform: "translate(133.333 66.667)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41",
    transform: "translate(25 11.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M0,0V19.238",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryAddress);
export default __webpack_public_path__ + "static/media/DeliveryAddress.a5826dfd5ce2cbc1aeabf4f2d65ba2d4.svg";
export { ForwardRef as ReactComponent };